<template>
  <div class="mx-auto">
    <TitleWrapper
      :filter-option="false"
      title="SITE_SETTS"
      tooltip-title="SITE_SETTS"
      :display-breadcrumb="true"
    ></TitleWrapper>
    <!-- <ValidationObserver v-slot="{ invalid, handleSubmit }" tag="div"> -->
    <div
      v-if="!isLoading"
      class="minHeightMainContent settings-bar pt-7 mt-3 px-3 md:px-7 border rounded-t-lg border-border-color-lighter"
    >
      <!-- Teacher Attendance Permission -->

      <InputFieldWrapper>
        <InputBox
          v-model.trim="siteSetting.instituteName"
          type="text"
          :rules="`required`"
          name="Institute Name"
          tooltip-desc="toolTipInfo.INSTITUTE_NAME"
          :tooltip-prop="true"
          title="Institute Name"
          label="Institute Name"
          placeholder="write"
          is-requried="true"
        />
        <InputBox
          v-model.trim="siteSetting.siteTitle"
          type="text"
          tooltip-desc="toolTipInfo.SITE_TITLE"
          name="SITE_TITLE"
          title="SITE_TITLE"
          :tooltip-prop="true"
          label="SITE_TITLE"
          rules="alpha_spaces"
          placeholder="SITE_TITLE"
        />
        <div>
          <InputBox
            id="input-type-file-logo"
            type="file"
            name="Logo"
            title="Logo"
            label="Logo"
            tooltip-desc="toolTipInfo.LOGO"
            :preview-image="previewImage"
            :tooltip-prop="true"
            :rules="`${!logoSrc ? 'required|' : ''}size:${imageSize}`"
            :file-src="!!logoSrc && !previewImage?.src"
            @preview="preview"
            @change="setLogo"
            @clearValue="clearSrcFileLogo"
          />
          <p class="text-xs -mt-3 mb-3 text-text-color-grey">
            Ideally image should be 512 X 512 (jpeg/png/jpg)
          </p>
        </div>
        <div>
          <InputBox
            id="input-type-file-favicon"
            type="file"
            name="Favicon"
            :tooltip-prop="true"
            title="Favicon"
            label="Favicon"
            tooltip-desc="toolTipInfo.FAVICON"
            class="border-none"
            :hidden="true"
            :rules="`${!faviconSrc ? 'required|' : ''}size:${imageSize}`"
            :file-src="!!faviconSrc && !faviconPreviewImage?.src"
            :preview-image="faviconPreviewImage"
            :disabled="faviconLoading"
            :is-component-in-loading="faviconLoading"
            placeholder="Choose File"
            @preview="faviconPreview"
            @change="setFavicon"
          />
          <p class="text-xs -mt-3 mb-3 text-text-color-grey">
            Ideally image should be less than 500 KB (jpeg/png/jpg)
          </p>
        </div>
      </InputFieldWrapper>

      <InputBox
        v-model.trim="siteSetting.siteUrl"
        type="text"
        name="GS_ESL"
        :disabled="siteSettingsData?.is_site_url_approved"
        title="GS_ESL"
        label="GS_ESL"
        placeholder="GS_ESL"
      />

      <h3
        class="mt-4 sm:mt-2 pb-5 text-lg leading-8 font-semibold text-primary-gray-700 flex items-center gap-5"
      >
        <span>Multiple Campuses</span>
        <ToggleButton v-model="siteSetting.multiple_campuses_allowed" :is-status-hide="true" />
      </h3>

      <div class="flex flex-wrap w-full md:w-3/6"></div>
      <div class="pb-5 md:pb-0">
        <button
          class="mt-5 mb-5 focus:outline-none focus:shadow-md ltr:text-base rtl:text-sm text-white font-rubik flex w-full md:w-40 py-2 justify-center primary-button"
          @click.prevent="apply"
        >
          {{ $t('dashboard.Save') }}
        </button>
      </div>
    </div>
    <div
      v-else
      class="settings-bar min-h-screen pt-7 mt-7 px-3 md:px-7 border rounded-t-lg border-border-color-lighter"
    >
      <Loader :content="true" />
    </div>
    <!-- </ValidationObserver> -->
  </div>
</template>

<script>
/* COMPONENTS */
import TitleWrapper from '@components/TitleWrapper.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import Loader from '@components/BaseComponent/Loader.vue'
// import { ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import { mapState, mapActions } from 'vuex'
import { objectDeepCopy } from '@src/utils/generalUtil.js'
import generalConstants from '@src/constants/general-constants.js'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'
import ToggleButton from '@src/components/BaseComponent/toggleButton.vue'
/* STORE */

export default {
  components: {
    TitleWrapper,
    InputBox,
    // ValidationObserver,
    Loader,
    InputFieldWrapper,
    ToggleButton,
  },
  beforeRouteLeave(to, from, next) {
    if (this.logoLoading || this.faviconLoading) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  page: {
    title: 'System Settings | site Settings',
    meta: [
      {
        name: 'description',
        content: 'site Settings',
      },
    ],
  },
  data() {
    return {
      previewImage: null,
      faviconPreviewImage: null,
      siteSetting: {
        instituteName: '',
        siteTitle: '',
        siteUrl: '',
        multiple_campuses_allowed: false,
      },
      dashboard: 'dashboard',
      imageSize: generalConstants.imageSize,
      logoLoading: false,
      faviconLoading: false,
      siteSettingsData: [],
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.layout.isLoading,
      logoSrc: (state) => state.settings.siteSettingLogoURL,
      faviconSrc: (state) => state.settings.siteSettingFaviconURL,
      systemSettings: (state) => state.layout.systemSettings,
    }),
  },
  created() {
    this.siteSetting.siteTitle = this.$store.state.settings.siteSettingSiteTitle || 'MyQampus'
    this.siteSetting.instituteName = this.$store.state.settings.siteSettingInstituteName
  },
  mounted() {
    this.getSettings()
  },
  methods: {
    preview(image) {
      this.previewImage = image
    },
    faviconPreview(image) {
      this.faviconPreviewImage = image
    },
    async setLogo(file, source, name) {
      if (file.size / 1024 > this.imageSize) return
      const formData = new FormData()
      formData.append('image', file)
      this.logoLoading = true
      const res = await this.setLogoAndFavicon({ formData, type: 'logo' })
      this.logoLoading = false
      if (res) {
        this.$store.commit('settings/GS_SET_LOGO', res[0]?.data?.image)
      }
    },
    async setFavicon(file, source, name, invalid) {
      if (file.size / 1024 > this.imageSize) return
      const formData = new FormData()
      formData.append('favicon', file)
      this.faviconLoading = true
      const res = await this.setLogoAndFavicon({ formData, type: 'favicon' })
      this.faviconLoading = false
      if (res) {
        this.$store.commit('settings/GS_SET_FAVICON', res[0]?.data?.favicon)
      }
    },
    async apply() {
      if (this.logoLoading || this.faviconLoading) return
      const data = {
        institute_name: this.siteSetting.instituteName,
        site_title: this.siteSetting.siteTitle,
        site_url: this.siteSetting.siteUrl,
        multiple_campuses_allowed: this.siteSetting.multiple_campuses_allowed,
      }
      const [res] = await this.updateInstituteGeneralSettings(data)
      this.updaateMultipleCampusesAllowed(
        res.data.multiple_campuses_allowed,
        res?.data?.campuses[0],
      )
    },
    getSettings() {
      this.getGeneralSettings().then((res) => {
        this.siteSettingsData = res?.data
        this.siteSetting.siteUrl = res?.data?.site_url
        this.siteSetting.instituteName = res?.data?.title
        this.siteSetting.multiple_campuses_allowed = res?.data?.multiple_campuses_allowed
        this.updaateMultipleCampusesAllowed(res?.data?.multiple_campuses_allowed)
      })
    },
    updaateMultipleCampusesAllowed(multiple_campuses_allowed, campus = '') {
      const systemSettings = objectDeepCopy(this.systemSettings)
      systemSettings.multiple_campuses_allowed = multiple_campuses_allowed
      this.$store.commit('layout/SET_INSTITUE_SETTINGS', systemSettings)
      if (!multiple_campuses_allowed && campus)
        this.$store.commit('layout/SET_SELECTED_CAMPUSE', campus, { root: true })
    },
    ...mapActions('settings', [
      'setDefaultSettings',
      'setLogoAndFavicon',
      'updateInstituteGeneralSettings',
      'getGeneralSettings',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.settings-bar {
  background-color: var(--bg-color-white);
}

.slider {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
  background-color: #ccc;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.slider::before {
  position: absolute;
  bottom: 3px;
  left: 3px;
  width: 17px;
  height: 16px;
  content: '';
  background-color: white;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
input:checked + .slider {
  background-color: var(--primary-green);
}
input:focus + .slider {
  box-shadow: 0 0 1px var(--primary-green);
}
input:checked + .slider::before {
  -webkit-transform: translateX(25px);
  -ms-transform: translateX(25px);
  transform: translateX(25px);
}
.previewImage {
  width: 100%;
  min-width: 100px;
  max-width: 300px;
  height: 100%;
  min-height: 100px;
  max-height: 300px;
  border-radius: 35px;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round::before {
  border-radius: 50%;
}
</style>
